import { useEffect, useState } from "react";

import { EventType } from "./useEvent";
import getTime from "../helpers/getTime";
import useTime from "./useTime";

const useEventTimer = () => {
  const now = useTime();
  const [event, setEvent] = useState<EventType>();

  useEffect(() => {
    if (now < getTime("26 Nov 2020")) {
      setEvent("SEAADE");
    } else if (now < getTime("28 Nov 2020")) {
      setEvent("IADR");
    } else {
      setEvent("SEAADE-IADR");
    }
  }, [now]);

  return event;
};

export default useEventTimer;
